import React, { useEffect } from "react";
import { Box, Button } from "@mui/material";

const ButtonSection = ({
  handleSaveNextDefault,
  handleMarkReviewDefault,
  handleClearResponse,
  handleSubmit,
  currentQuestion,
  handleBack,
  sectionNames,
  subjectNames,
  activeSubjectId,
  activeSectionId,
  setActiveSectionId,
  setActiveSubjectId,
  question,
  questionData,
  handleNext,
}) => {
  const switchSection = () => {
    // Only proceed if we're at the last question
    if (currentQuestion !== questionData?.length - 1) return;

    // Find current subject and section indices
    const subjectCurrentIndex = subjectNames.findIndex(
      (item) => item.subject_id === activeSubjectId
    );

    // Check if we're already at the very last section of the last subject
    const isLastSectionOfLastSubject =
      subjectCurrentIndex === subjectNames.length - 1 &&
      sectionNames[subjectCurrentIndex]?.length - 1 ===
        sectionNames[subjectCurrentIndex]?.findIndex(
          (section) => section.section_id === activeSectionId
        );

    if (isLastSectionOfLastSubject) {
      return;
    }

    // Find current section index within current subject
    let sectionCurrentIndex = -1;
    if (sectionNames[subjectCurrentIndex]) {
      sectionCurrentIndex = sectionNames[subjectCurrentIndex].findIndex(
        (section) => section.section_id === activeSectionId
      );
    }

    // If not found in current subject, search all subjects
    if (sectionCurrentIndex === -1) {
      for (let i = 0; i < sectionNames.length; i++) {
        const foundIndex = sectionNames[i].findIndex(
          (section) => section.section_id === activeSectionId
        );
        if (foundIndex !== -1) {
          sectionCurrentIndex = foundIndex;
          // Update subject index if section was found in different subject
          if (i !== subjectCurrentIndex) {
            subjectCurrentIndex = i;
          }
          break;
        }
      }
    }

    // Determine next section
    if (sectionCurrentIndex !== -1) {
      // Check if there's a next section in current subject
      if (sectionCurrentIndex + 1 < sectionNames[subjectCurrentIndex].length) {
        setActiveSectionId(
          sectionNames[subjectCurrentIndex][sectionCurrentIndex + 1].section_id
        );
      }
      // Otherwise move to first section of next subject
      else if (subjectCurrentIndex + 1 < subjectNames.length) {
        setActiveSubjectId(subjectNames[subjectCurrentIndex + 1].subject_id);
        setActiveSectionId(sectionNames[subjectCurrentIndex + 1][0].section_id);
      }
    } else {
      console.error("Section not found in any subject");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        // backgroundColor: "#f0f0f0",
        p: 2,
      }}
    >
      {/* Left buttons */}
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        <Button
          variant="outlined"
          sx={{ borderColor: "black", color: "black", borderRadius: "0px" }}
          onClick={() => {
            handleMarkReviewDefault("marked");
            switchSection();
          }}
        >
          Mark for Review & Next
        </Button>
        {/* <Button
          variant="outlined"
          sx={{ backgroundColor: "#cce5ff", color: "black" }}
          onClick={handleNext}
          disabled={currentQuestion === questionData?.length - 1}
        >
          Skip
        </Button> */}
        <Button
          variant="outlined"
          sx={{ borderColor: "black", color: "black", borderRadius: "0px" }}
          onClick={handleClearResponse}
        >
          Clear Response
        </Button>
      </Box>

      {/* Right button */}
      <Box>
        {currentQuestion !== 0 && (
          <Button
            variant="outlined"
            sx={{
              borderColor: "black",
              color: "black",
              borderRadius: "0px",
              mr: 2,
            }}
            onClick={() => {
              handleBack();
            }}
          >
            Previous
          </Button>
        )}
        <Button
          variant="contained"
          sx={{
            borderRadius: "0px",
            backgroundColor: "#337ab7",
            "&:hover": { backgroundColor: "#286090" },
          }}
          onClick={() => {
            handleSaveNextDefault();
            switchSection();
          }}
        >
          Save & Next
        </Button>
      </Box>
    </Box>
  );
};

export default ButtonSection;
